import React, { useContext, useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import "../../../assets/css/gcadmin/managebooks/ManageBooksPage.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";
import Pagination from "../../../components/general/pagination/Pagination";
import Loader from "../../../components/general/loader/Loader";

/* ── Categories ── */
const CATEGORIES = [
  "Computer Science",
  "Information Technology",
  "Islamic Studies",
  "English",
  "Education",
  "Mathematics",
  "Physics",
  "Botony",
  "Zology",
  "Economics",
  "Chemistry",
  "Fine Arts",
  "Commerce",
  "Psychology",
];

/* ══════════════════════════════════════════
   Add / Edit Modal
══════════════════════════════════════════ */
const BookModal = ({ book, onClose, onSaveSuccess }) => {
  const [form, setForm]       = useState({
    title:        book?.title        || "",
    author:       book?.author       || "",
    accession_no: book?.accession_no || "",
    dept:         book?.dept         || "",
    total_copies: book?.total_copies || 0,
    is_donated:   book?.is_donated   || false,
    img:          null,
    imgPreview:   book?.img ? `http://127.0.0.1:8000/storage/${book.img}` : null,
  });
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileRef               = useRef(null);
  const [errors, setErrors] = useState({});
  const { baseUrl, authToken, validateBookForm, } = useContext(AppContext);

  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);

  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const set = (k) => (e) => {
    const val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm(p => ({ ...p, [k]: val }));
  };

  const handleImage = (e) => {

    const f = e.target.files[0];

    if (!f) return;

    setErrors((prev) => ({
        ...prev,
        img: "",
    }));

    const reader = new FileReader();

    reader.onload = (ev) =>
        setForm((p) => ({
            ...p,
            img: f,
            imgPreview: ev.target.result,
        }));

    reader.readAsDataURL(f);
};
  const handleSubmit = (e) => {
    e.preventDefault();

    
    
const validationErrors = validateBookForm({
    title: form.title,
    author: form.author,
    accessionNo: form.accession_no,
    program: form.dept,
    totalCopies: form.total_copies,
    coverImage: form.img,
});
console.log("Token:", authToken);
console.log(validationErrors);
setErrors(validationErrors);

if (Object.keys(validationErrors).length > 0) {
    return;
}
    setLoading(true);
    const formData = new FormData();
    formData.append("title",        form.title);
    formData.append("author",       form.author);
    formData.append("accession_no", form.accession_no);
    formData.append("dept",         form.dept);
    formData.append("total_copies", form.total_copies.toString());
    formData.append("is_donated",   form.is_donated ? "1" : "0");
    if (form.img instanceof File) formData.append("img", form.img);

    const url = book
      ? `${baseUrl}/admin/books/update/${book.id}`
      : `${baseUrl}/admin/books/addBook`;

    axios
      .post(url, formData, { headers: { "Authorization": `Bearer ${authToken}` } })
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          Swal.fire({
            icon: "success",
            title: book ? "Updated!" : "Added!",
            text: book ? "Book updated successfully." : "Book added successfully.",
            confirmButtonText: "Great",
          });
          onSaveSuccess();
          handleClose();
        } else {
          Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Operation failed." });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  };

  return (
    <div
      className={`gcAdminMB-backdrop ${visible ? "gcAdminMB-backdrop--in" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`gcAdminMB-modal ${visible ? "gcAdminMB-modal--in" : ""}`}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="gcAdminMB-modal-header">
          <h5 className="gcAdminMB-modal-title">{book ? "Edit Book" : "Add New Book"}</h5>
          <button className="gcAdminMB-modal-close" onClick={handleClose}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="gcAdminMB-modal-body">

          {/* Title */}
          <div className="gcAdminMB-form-group">
            <label className="gcAdminMB-form-label">Title *</label>
            <input
className="gcAdminMB-form-input"
type="text"
placeholder="Book title"
value={form.title}
onChange={(e) => {
    set("title")(e);
    setErrors((prev) => ({ ...prev, title: "" }));
}}
/>

{errors.title && (
    <small className="text-danger">{errors.title}</small>
)}
          </div>

          {/* Author */}
          <div className="gcAdminMB-form-group">
            <label className="gcAdminMB-form-label">Author *</label>
            <input
className="gcAdminMB-form-input"
type="text"
placeholder="Author name"
value={form.author}
onChange={(e) => {
    set("author")(e);
    setErrors((prev) => ({ ...prev, author: "" }));
}}
/>

{errors.author && (
    <small className="text-danger">{errors.author}</small>
)}
          </div>

          {/* Accession + Department (side by side) */}
          <div className="gcAdminMB-form-row">
            <div className="gcAdminMB-form-group gcAdminMB-form-half">
              <label className="gcAdminMB-form-label">Accession No *</label>
              <input
className="gcAdminMB-form-input"
type="text"
placeholder="e.g. ACC-001"
value={form.accession_no}
onChange={(e) => {
    set("accession_no")(e);
    setErrors((prev) => ({ ...prev,  accessionNo: "" }));
}}
/>

{errors.accessionNo && (
    <small className="text-danger">
      {errors.accessionNo}
    </small>
  )}
            </div>
            <div className="gcAdminMB-form-group gcAdminMB-form-half">
              <label className="gcAdminMB-form-label">Program *</label>
              <div className="gcAdminMB-select-wrap">
  <select
  className="gcAdminMB-form-select"
  value={form.dept}
  onChange={(e) => {
    set("dept")(e);

    setErrors((prev) => ({
      ...prev,
      program: "",
    }));
  }}
>
  <option value="">Select Program</option>

  {CATEGORIES.map((c) => (
    <option key={c} value={c}>
      {c}
    </option>
  ))}
</select>

  <span className="gcAdminMB-select-arrow">
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 9l6 6 6-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
</div>

{errors.program && (
    <small className="text-danger">
        {errors.program}
    </small>
)}
                
            </div>
          </div>

          {/* Total Copies */}
          <div className="gcAdminMB-form-group">
            <label className="gcAdminMB-form-label">Total Copies *</label>
            <input
className="gcAdminMB-form-input"
type="number"
min="0"
placeholder="Number of copies"
value={form.total_copies}
onChange={(e) => {
    set("total_copies")(e);
    setErrors((prev) => ({ ...prev, totalCopies: "" }));
}}
/>

{errors.totalCopies && (
    <small className="text-danger">
        {errors.totalCopies}
    </small>
)}
          </div>

           {/* Cover Image */}
<div className="gcAdminMB-form-group">
  <label className="gcAdminMB-form-label">Cover Image *</label>

  <div
    className={`gcAdminMB-cover-upload ${
      form.imgPreview ? "gcAdminMB-cover-upload--has" : ""
    }`}
    onClick={() => fileRef.current?.click()}
  >
    {form.imgPreview ? (
      <img
        src={form.imgPreview}
        alt="Cover"
        className="gcAdminMB-cover-preview"
      />
    ) : (
      <>
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <path d="M21 15l-5-5L5 21" />
        </svg>

        <p className="gcAdminMB-cover-text">
          Click to upload cover image
        </p>

        <p className="gcAdminMB-cover-hint">
          JPG, PNG (max 5MB)
        </p>
      </>
    )}
  </div>

  <input
    ref={fileRef}
    type="file"
    accept="image/*"
    style={{ display: "none" }}
    onChange={handleImage}
  />

  {errors.coverImage && (
    <small className="text-danger">
        {errors.coverImage}
    </small>
)}
</div>
          {/* Donated Checkbox */}
          <div className="gcAdminMB-check-row">
            <label className="gcAdminMB-check-label">
              <input type="checkbox" checked={form.is_donated} onChange={set("is_donated")} />
              <span className="gcAdminMB-check-box" />
              <span className="gcAdminMB-check-text">This is a donated book</span>
            </label>
          </div>

          {/* Footer Buttons */}
          <div className="gcAdminMB-modal-footer">
            <button type="submit" className="gcAdminMB-save-btn" disabled={loading}>
              {loading ? (book ? "Saving..." : "Adding...") : (book ? "Save Changes" : "Add Book")}
            </button>
            <button type="button" className="gcAdminMB-cancel-btn" onClick={handleClose}>
              Cancel
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Delete Modal
══════════════════════════════════════════ */
const DeleteModal = ({ book, onClose, onDeleteSuccess }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { baseUrl, authToken } = useContext(AppContext);

  useEffect(() => { setTimeout(() => setVisible(true), 30); }, []);
  const handleClose = () => { setVisible(false); setTimeout(onClose, 280); };

  const handleConfirm = () => {
    setLoading(true);
    axios
      .delete(`${baseUrl}/admin/books/delete/${book.id}`,
        { headers: { "Authorization": `Bearer ${authToken}` } }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          Swal.fire({ icon: "success", title: "Deleted!", text: "Book deleted successfully.", confirmButtonText: "OK" });
          onDeleteSuccess();
          handleClose();
        } else {
          Swal.fire({ icon: "error", title: "Failed", text: res.data.message || "Delete failed." });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong. Please try again." });
      });
  };

  return (
    <div
      className={`gcAdminMB-backdrop ${visible ? "gcAdminMB-backdrop--in" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`gcAdminMB-modal gcAdminMB-modal--sm ${visible ? "gcAdminMB-modal--in" : ""}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="gcAdminMB-delete-icon">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"
              stroke="#d63031" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 11v4M14 11v4"
              stroke="#d63031" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
        </div>
        <h5 className="gcAdminMB-delete-title">Delete Book?</h5>
        <p className="gcAdminMB-delete-msg">
          Are you sure you want to delete <strong>"{book.title}"</strong>?<br/>
          This action cannot be undone.
        </p>
        <div className="gcAdminMB-delete-actions">
          <button className="gcAdminMB-delete-cancel" onClick={handleClose}>Cancel</button>
          <button className="gcAdminMB-delete-confirm" onClick={handleConfirm} disabled={loading}>
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════
   Main Page
══════════════════════════════════════════ */
const ITEMS_PER_PAGE = 10; // yahan se page size control hoti hai

const ManageBooksPage = () => {
  const [books,      setBooks]      = useState([]);
  const [search,     setSearch]     = useState("");
  const [showAdd,    setShowAdd]    = useState(false);
  const [editBook,   setEditBook]   = useState(null);
  const [deleteBook, setDeleteBook] = useState(null);
  const [visible,    setVisible]    = useState(false);
  const [loading,    setLoading]    = useState(false); // initial API fetch loading
  const [rowVisible, setRowVisible] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // pagination state
  const { baseUrl, authToken }      = useContext(AppContext);

  // ── Pagination/search change hone par sirf current page (10 records)
  //    ki "loading" dikhane ke liye — poori list ek sath nahi ──
  const [viewLoading, setViewLoading] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => { setTimeout(() => setVisible(true), 60); }, []);

  /* ── Fetch All Books ── */
  const fetchAllBooks = () => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/books/fetchAllBooks`,
        { headers: { "Authorization": `Bearer ${authToken}` } })
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setBooks(res.data.books);
          setRowVisible([]);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Fetch error:", err);
      });
  };

  useEffect(() => { fetchAllBooks(); }, []);

  /* ── Filter ── */
  const filtered = books.filter(b =>
    b.title?.toLowerCase().includes(search.toLowerCase())        ||
    b.author?.toLowerCase().includes(search.toLowerCase())       ||
    b.dept?.toLowerCase().includes(search.toLowerCase())         ||
    b.accession_no?.toLowerCase().includes(search.toLowerCase())
  );

  /* ── Pagination slice (sirf current page ka data table ko jayega) ── */
  const paginatedData = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  /* ── Search change hone par page 1 pe reset ── */
  useEffect(() => {
    setCurrentPage(1);
    // eslint-disable-next-line
  }, [search]);

  /* ── Staggered Row Animation (ab paginatedData ke hisaab se) ── */
  useEffect(() => {
    setRowVisible([]);
    paginatedData.forEach((_, i) => {
      setTimeout(() => {
        setRowVisible(prev => { const n = [...prev]; n[i] = true; return n; });
      }, i * 55);
    });
    // eslint-disable-next-line
  }, [search, books, currentPage]);

  /* ── Sirf visible (current page ke) records ki loading dikhayein:
     - Jab search change ho
     - Jab pagination se dusre page par jayen (next page ki 10 records ki loading)
     Poori list ek sath "pop" nahi hogi. ── */
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setViewLoading(true);
    const timer = setTimeout(() => setViewLoading(false), 400);
    return () => clearTimeout(timer);
  }, [currentPage, search]);

  const showLoader = loading || viewLoading;

  return (
    <div className={`gcAdminMB-page ${visible ? "gcAdminMB-page--visible" : ""}`}>
      <Container fluid className="gcAdminMB-container">

        {/* ── Header ── */}
        <div className="gcAdminMB-header">
          <h2 className="gcAdminMB-title">Manage Books</h2>
          <button className="gcAdminMB-add-btn" onClick={() => setShowAdd(true)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"/>
            </svg>
            Add Book
          </button>
        </div>

        {/* ── Search ── */}
        <div className="gcAdminMB-search-row">
          <div className="gcAdminMB-search-wrap">
            <input
              className="gcAdminMB-search-input"
              type="text"
              placeholder="Search by title, author, department or accession no..."
              value={search}
              onChange={e => { setSearch(e.target.value); setRowVisible([]); }}
            />
            <button className="gcAdminMB-search-btn" aria-label="Search">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.9"/>
                <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        {/* ── Table ── */}
        <div className="gcAdminMB-table-wrap">
          {showLoader ? (
            <Loader message={loading ? "Books loading, Please wait..." : "Loading books..."} />
          ) : (
            <>
              <table className="gcAdminMB-table">
                <colgroup>
                  <col style={{ width: "30%" }} /> {/* Title      */}
                  <col style={{ width: "20%" }} /> {/* Author     */}
                  <col style={{ width: "14%" }} /> {/* Accession  */}
                  <col style={{ width: "18%" }} /> {/* Department */}
                  <col style={{ width: "9%"  }} /> {/* Copies     */}
                  <col style={{ width: "9%"  }} /> {/* Actions    */}
                </colgroup>

                <thead>
                  <tr className="gcAdminMB-thead-row">
                    <th className="gcAdminMB-th">Title</th>
                    <th className="gcAdminMB-th">Author</th>
                    <th className="gcAdminMB-th">Accession No</th>
                    <th className="gcAdminMB-th">Department</th>
                    <th className="gcAdminMB-th gcAdminMB-th--center">Copies</th>
                    <th className="gcAdminMB-th gcAdminMB-th--center">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.map((book, i) => (
                    <tr
                      key={book.id}
                      className={`gcAdminMB-tr ${rowVisible[i] ? "gcAdminMB-tr--visible" : ""}`}
                      style={{ transitionDelay: `${i * 0.05}s` }}
                    >
                      {/* ── Title (text only — no icon/thumb) ── */}
                      <td className="gcAdminMB-td gcAdminMB-td--title">
                        <span className="gcAdminMB-title-text">{book.title}</span>
                      </td>

                      <td className="gcAdminMB-td gcAdminMB-td--author">{book.author}</td>

                      <td className="gcAdminMB-td gcAdminMB-td--acc">
                        {book.accession_no || "—"}
                      </td>

                      <td className="gcAdminMB-td">
                        <span className="gcAdminMB-badge">{book.dept || "—"}</span>
                      </td>

                      <td className="gcAdminMB-td gcAdminMB-td--center">
                        <span className={`gcAdminMB-pill ${book.total_copies === 0 ? "gcAdminMB-pill--zero" : "gcAdminMB-pill--ok"}`}>
                          {book.total_copies}
                        </span>
                      </td>

                      <td className="gcAdminMB-td gcAdminMB-td--center">
                        <div className="gcAdminMB-actions">
                          <button
                            className="gcAdminMB-action-btn gcAdminMB-action-btn--edit"
                            onClick={() => setEditBook(book)}
                            title="Edit Book"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
                                stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"/>
                              <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                                stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </button>
                          <button
                            className="gcAdminMB-action-btn gcAdminMB-action-btn--delete"
                            onClick={() => setDeleteBook(book)}
                            title="Delete Book"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                              <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"
                                stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}

                  {filtered.length === 0 && (
                    <tr>
                      <td colSpan={6} className="gcAdminMB-td gcAdminMB-td--empty">
                        No books found. Click "Add Book" to add one.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <Pagination
                currentPage={currentPage}
                totalItems={filtered.length}
                itemsPerPage={ITEMS_PER_PAGE}
                onPageChange={setCurrentPage}
              />
            </>
          )}
        </div>

      </Container>

      {/* ── Modals ── */}
      {(showAdd || editBook) && (
        <BookModal
          book={editBook}
          onClose={() => { setShowAdd(false); setEditBook(null); }}
          onSaveSuccess={fetchAllBooks}
        />
      )}
      {deleteBook && (
        <DeleteModal
          book={deleteBook}
          onClose={() => setDeleteBook(null)}
          onDeleteSuccess={fetchAllBooks}
        />
      )}
    </div>
  );
};

export default ManageBooksPage;